import { render } from "./AppLaunch.vue?vue&type=template&id=3cf4f248&scoped=true"
import script from "./AppLaunch.vue?vue&type=script&lang=js"
export * from "./AppLaunch.vue?vue&type=script&lang=js"

import "./AppLaunch.vue?vue&type=style&index=0&id=3cf4f248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf4f248"]])

export default __exports__